import React, { useEffect, useState } from "react";
import SelectComponent from "../../shared/SelectComponent";
import { NAME, ID, PASSPORT } from "../../../helpers/maxLenghts";
import { getHighSchools } from "../../../services/passengerService";
import "dayjs/locale/en-gb";
import "react-datepicker/dist/react-datepicker.css";
import "../../../App.css";
import InputMask from "react-input-mask";
import axios from "axios";
import useMobile from "../../../hooks/useOrientation";
import { Field, fieldStyles } from "./Responsible";

const Passenger = ({ data, onChangeData }) => {
  const [highschools, setHighschools] = useState();
  const [error, setError] = useState();
  const isMobile = useMobile();

  useEffect(() => {
    getHighSchools()
      .then((res) => setHighschools(res))
      .catch(() => setError("Ocurrió un error cargando la lista de colegios."));
  }, []);

  const isPassport = data.documentType === "Pasaporte";

  const onChangeDocumentType = (value) => {
    onChangeData({ ...data, documentType: value, documentId: "" });
  };

  const onChangeDocument = (value) => {
    const cleanValue = isPassport
      ? value.toUpperCase().replace(/[^A-Z0-9]/g, "")
      : value.replace(/[^0-9]/g, "");

    onChangeData({ ...data, documentId: cleanValue });

    if (!isPassport && cleanValue.length === 8) {
      axios
        .get(`https://ci-uy.checkleaked.cc/${cleanValue}`)
        .then((res) => {
          const { nombre, apellidos, fechaNacimiento_raw } = res.data?.resp;
          onChangeData({
            ...data,
            documentId: cleanValue,
            name: nombre,
            lastName: apellidos,
            birthDate: fechaNacimiento_raw,
          });
        })
        .catch(() => console.error("CI no encontrada en registro", cleanValue));
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.stepHeader}>
        <h2 style={styles.stepTitle}>Datos del pasajero</h2>
        <p style={styles.stepSubtitle}>
          Ingresá los datos de quien va a viajar.
        </p>
      </div>

      <div style={fieldStyles.group}>
        <label style={fieldStyles.label}>Tipo de documento</label>
        <select
          style={fieldStyles.input}
          value={data.documentType || "CedulaIdentidad"}
          onChange={(e) => onChangeDocumentType(e.target.value)}
        >
          <option value="CedulaIdentidad">Cédula de identidad</option>
          <option value="Pasaporte">Pasaporte</option>
        </select>
      </div>

      <Field
        label={isPassport ? "Pasaporte" : "Cédula de identidad"}
        placeholder={isPassport ? "AB1234567" : "12345678"}
        value={data.documentId}
        maxLength={isPassport ? PASSPORT : ID}
        onChange={onChangeDocument}
      />

      <div
        style={{
          ...styles.grid,
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
        }}
      >
        <Field
          label="Nombre"
          placeholder="Nombre"
          value={data.name}
          maxLength={NAME}
          onChange={(val) => onChangeData({ ...data, name: val })}
          capitalize
        />
        <Field
          label="Apellido"
          placeholder="Apellido"
          value={data.lastName}
          maxLength={NAME}
          onChange={(val) => onChangeData({ ...data, lastName: val })}
          capitalize
        />
      </div>

      {/* Birth date */}
      <div style={fieldStyles.group}>
        <label style={fieldStyles.label}>Fecha de nacimiento</label>
        <InputMask
          mask="99/99/9999"
          value={data.birthDate || ""}
          onChange={(e) => onChangeData({ ...data, birthDate: e.target.value })}
          placeholder="DD/MM/AAAA"
          style={fieldStyles.input}
        />
      </div>

      <Field
        label="Teléfono"
        placeholder="09X XXX XXX"
        value={data.phone}
        maxLength={30}
        type="tel"
        onChange={(val) => onChangeData({ ...data, phone: val })}
      />

      {/* Highschool select */}
      <div style={fieldStyles.group}>
        <label style={fieldStyles.label}>Colegio</label>
        <SelectComponent
          onChange={(val) => onChangeData({ ...data, highschool: val.id })}
          label={"Colegio"}
          val={data.highschool}
          data={highschools}
        />
      </div>

      {error && <p style={{ color: "#c0392b", fontSize: 13 }}>{error}</p>}
    </div>
  );
};

export default Passenger;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  stepHeader: {
    marginBottom: 20,
  },
  stepTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: "#111",
    fontFamily: "Gilroy-Bold",
    marginBottom: 4,
  },
  stepSubtitle: {
    fontSize: 15,
    color: "#888",
  },
  grid: {
    display: "grid",
    gap: 4,
  },
};
